/* =============================================================
   D'Avila Cart Page — JS
   - Quantidade (+/-) atualiza via /cart/change.js
   - Remover item atualiza via /cart/change.js quantity=0
   - Rerender do resumo em tempo real
   ============================================================= */
(function () {
  'use strict';

  function formatBRL(cents) {
    // Guard: se cents inválido (NaN, undefined, null), usa 0 pra não vazar "R$ NaN" na UI
    var safe = (typeof cents === 'number' && isFinite(cents)) ? cents : 0;
    var reais = (safe / 100).toFixed(2).replace('.', ',');
    var parts = reais.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts.join(',');
  }

  // =============================================================
  // Melhor cupom automatico — compara cupom global (order) contra
  // cupons de produto/colecao aplicaveis apenas em itens elegiveis.
  // Aplica automaticamente o vencedor via /discount/CODIGO?redirect=/cart.
  // Anti-loop: sessionStorage guarda o ultimo cupom aplicado + assinatura
  // do carrinho (evita reaplicar em cada refresh).
  // =============================================================
  function computeBestCoupon() {
    var wrap = document.querySelector('[data-davila-cart]');
    if (!wrap) return null;
    var globalCode = (wrap.dataset.globalCoupon || '').trim();
    var globalPct = parseInt(wrap.dataset.globalPct || '0', 10);

    // Ignora itens em animacao de saida (evita calcular com garfo que ta sendo removido)
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-cart-item]'))
      .filter(function (li) { return !li.classList.contains('is-removing'); });
    if (!items.length) return null;

    // Agrupa cents elegiveis por codigo de cupom (product/colecao)
    var byCode = {};
    var cartTotal = 0;
    items.forEach(function (li) {
      var cents = parseInt(li.dataset.itemCents || '0', 10);
      cartTotal += cents;
      var code = (li.dataset.itemCoupon || '').trim();
      var pct = parseInt(li.dataset.itemCouponPct || '0', 10);
      if (code && pct > 0) {
        if (!byCode[code]) byCode[code] = { pct: pct, cents: 0 };
        byCode[code].cents += cents;
      }
    });

    // Monta lista de candidatos com desconto absoluto
    var candidates = [];
    Object.keys(byCode).forEach(function (code) {
      var info = byCode[code];
      candidates.push({ code: code, pct: info.pct, discount: Math.round(info.cents * info.pct / 100), scope: 'product' });
    });
    if (globalCode && globalPct > 0) {
      candidates.push({ code: globalCode, pct: globalPct, discount: Math.round(cartTotal * globalPct / 100), scope: 'order' });
    }
    if (!candidates.length) return null;
    candidates.sort(function (a, b) { return b.discount - a.discount; });
    return candidates[0];
  }

  function cartSignature() {
    // Assinatura = concat de key:qty ordenado (ignorando itens em animacao de saida).
    // Muda quando itens mudam de fato (removidos ou qty alterada).
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-cart-item]'))
      .filter(function (li) { return !li.classList.contains('is-removing'); });
    return items.map(function (li) {
      var qtyInput = li.querySelector('[data-davila-qty-input]');
      return (li.dataset.itemKey || '') + ':' + (qtyInput ? qtyInput.value : '?');
    }).sort().join('|');
  }

  // DESATIVADO em 2026-08-21: aplicacao automatica via redirect causava
  // conflito com extensoes de cupom/cashback dos clientes (Honey, Cuponomia,
  // etc) — ambos tentavam redirecionar pra /discount/X ao mesmo tempo.
  // Substituido por renderCouponSuggestion(): mostra sugestao visual + botao
  // "copiar codigo" pra cliente colar manualmente no checkout.
  function applyBestCouponIfNeeded() { /* no-op */ }

  // Renderiza banner de sugestao com o melhor cupom detectado (nao aplica
  // automaticamente). Cliente clica em "Copiar" e cola no campo de cupom
  // no checkout.
  //
  // PRIORIDADE:
  //   1. Se cliente veio via ?ref=CODIGO de influencer (localStorage) —
  //      SEMPRE sugere esse cupom (attribution do parceiro prevalece).
  //   2. Senao, computa o melhor cupom disponivel dos produtos.
  function renderCouponSuggestion() {
    var container = document.querySelector('[data-davila-coupon-suggestion]');
    if (!container) return;
    var wrap = document.querySelector('[data-davila-cart]');
    if (!wrap) { container.innerHTML = ''; return; }

    // 1. Cupom do influencer tem PRIORIDADE
    var refCoupon = typeof window.davilaGetRefCoupon === 'function'
      ? window.davilaGetRefCoupon()
      : null;

    var chosen = null;
    if (refCoupon) {
      chosen = { code: refCoupon, source: 'influencer' };
    } else {
      var best = computeBestCoupon();
      if (best) chosen = { code: best.code, discount: best.discount, source: 'product' };
    }
    if (!chosen) { container.innerHTML = ''; return; }

    var alreadyApplied = (wrap.dataset.appliedCoupons || '').toUpperCase().split(',').filter(Boolean);
    // Se JA tem CUPOM aplicado, esconde a sugestao inteira — a linha "Cupom X aplicado + Remover"
    // aparece no summary via updateCouponUI (nao aqui). Container fica vazio.
    if (alreadyApplied.length > 0) { container.innerHTML = ''; return; }

    // Monta hint de sugestao
    var icon = chosen.source === 'influencer' ? '🎁' : '💡';
    var suggestionText = chosen.source === 'influencer' ? 'Use o cupom exclusivo do parceiro:' : 'Sugestão: use';
    container.innerHTML =
      '<div class="davila-cart__coupon-hint">' +
        '<span>' + icon + ' ' + suggestionText + '</span>' +
        '<span class="davila-cart__coupon-hint-code">' + chosen.code + '</span>' +
        (chosen.source === 'influencer' ? '' : '<span>e economize <strong>' + formatBRL(chosen.discount) + '</strong></span>') +
        '<button type="button" class="davila-cart__coupon-hint-apply" data-davila-apply-code>Aplicar</button>' +
      '</div>';

    var btn = container.querySelector('[data-davila-apply-code]');
    if (btn) {
      btn.addEventListener('click', function () { applyCoupon(chosen.code, btn); });
    }
  }

  // Aplica cupom SEM reload: fetch /discount/CODE?redirect=/cart.js
  // Shopify seta cookie discount_code + retorna cart JSON com total_price
  // ja descontado. updateCouponUI detecta o cupom via cookie fallback.
  function applyCoupon(code, btnEl) {
    if (btnEl) { btnEl.textContent = 'Aplicando…'; btnEl.disabled = true; }
    var codeUpper = code.toUpperCase();
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Cupom aplicou se total_price ficou < original OU se o cookie foi setado
        var appliedByTotal = (cart.original_total_price || 0) > (cart.total_price || 0);
        var cookieCode = readDiscountCodeCookie();
        if (!appliedByTotal && cookieCode !== codeUpper) {
          if (btnEl) { btnEl.textContent = 'Cupom inválido'; btnEl.disabled = false; }
          setTimeout(function () { if (btnEl) btnEl.textContent = 'Aplicar'; }, 2500);
          return;
        }
        // Atualiza UI in-place: summary, linha de desconto, form -> "Aplicado + Remover"
        applyCartUpdate(cart, null, null, null);
      })
      .catch(function (err) {
        console.error('[applyCoupon] erro:', err);
        if (btnEl) { btnEl.textContent = 'Erro — tente de novo'; btnEl.disabled = false; }
      });
  }

  // Remove cupom SEM reload: /cart/update.js discount:'' + limpa cookie.
  function removeCoupon(btnEl) {
    if (btnEl) { btnEl.textContent = 'Removendo…'; btnEl.disabled = true; }
    // Limpa cookie discount_code direto (importante: Shopify usa cookie
    // como fonte-da-verdade em algumas rotas)
    try { document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'; } catch (e) { /* segue */ }
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '', attributes: { _davila_auth_coupon: '' } })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyCartUpdate(cart, null, null, null); })
      .catch(function () {
        if (btnEl) { btnEl.textContent = 'Erro'; btnEl.disabled = false; }
      });
  }

  // =============================================================
  // Auto-limpeza de cupom nao autorizado:
  // Se o cart tem cupom aplicado que NAO foi por click do cliente
  // nesta sessao (ex: cliente entrou por link antigo /discount/X, ou
  // por card antigo que redirecionava), remove automaticamente.
  //
  // Como funciona: o botao "Aplicar cupom" e o form manual redirecionam
  // pra /discount/CODE?redirect=/cart%3F_da%3D1 — o param _da=1 marca
  // que a aplicacao foi INTENCIONAL. Se o cart tem cupom E a URL nao
  // tem _da=1 E nao tem aplicacao recente no sessionStorage, limpa.
  //
  // Anti-loop: apos limpar via /discount/CLEAR{ts}?redirect=/cart, o
  // cart volta SEM cupom, entao o proximo carregamento nao entra no if.
  // =============================================================
  function wasRecentlyAuthorized(code) {
    try {
      var raw = sessionStorage.getItem('davila_coupon_recent') || '';
      if (!raw) return false;
      // Formato: CODE|timestamp
      var parts = raw.split('|');
      if (parts[0].toUpperCase() !== code.toUpperCase()) return false;
      var ts = parseInt(parts[1] || '0', 10);
      var ageMin = (Date.now() - ts) / 60000;
      return ageMin < 30; // aplicacao valida por 30min
    } catch (e) { return false; }
  }

  function markCouponAuthorized(code) {
    try {
      sessionStorage.setItem('davila_coupon_recent', code.toUpperCase() + '|' + Date.now());
    } catch (e) { /* segue */ }
  }

  function cleanUnauthorizedCoupons(cart) {
    if (!cart) return false;
    // Coleta discounts aplicados (excluindo frete gratis e automatic)
    var allDiscounts = [];
    if (cart.discount_applications && cart.discount_applications.length) {
      allDiscounts = allDiscounts.concat(cart.discount_applications);
    }
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      allDiscounts = allDiscounts.concat(cart.cart_level_discount_applications);
    }
    if (!allDiscounts.length) return false;

    var applied = allDiscounts
      .filter(function (d) { return d.target_type !== 'shipping_line' && d.type !== 'automatic'; })
      .map(function (d) { return (d.title || d.code || '').toUpperCase(); })
      .filter(Boolean);
    if (!applied.length) return false;

    // Autorizacao: cart.attributes._davila_auth_coupon persiste no cart (mais
    // robusto que sessionStorage — sobrevive a fechar aba, trocar browser).
    // Setado quando cliente clica "Aplicar cupom" no cart page.
    var authInCart = ((cart.attributes || {})._davila_auth_coupon || '').toUpperCase();

    // URL _da=1 = cliente acabou de aplicar (backup, caso attribute nao esteja setado ainda)
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('_da') === '1') {
      applied.forEach(function (c) { markCouponAuthorized(c); });
      urlParams.delete('_da');
      var newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
      if (window.history && window.history.replaceState) window.history.replaceState({}, '', newUrl);
      console.log('[coupon-cleaner] cupom autorizado por _da=1:', applied);
      return false;
    }

    // Se o cupom aplicado bate com o autorizado no cart, deixa
    if (authInCart && applied.indexOf(authInCart) !== -1) {
      console.log('[coupon-cleaner] cupom autorizado via cart.attributes:', authInCart);
      return false;
    }

    // Fallback sessionStorage (se cliente aplicou em outra aba nesta mesma sessao)
    var unauthorized = applied.filter(function (c) { return !wasRecentlyAuthorized(c); });
    if (!unauthorized.length) return false;

    console.log('[coupon-cleaner] removendo cupom nao autorizado via /cart/update.js:', unauthorized);
    // Doc oficial Shopify (mai/2025): POST /cart/update.js com { discount:'' } remove cupom.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (r) { return r.json(); })
      .then(function (updatedCart) {
        console.log('[coupon-cleaner] cupom removido. discount_applications:', updatedCart.discount_applications);
        window.location.reload();
      })
      .catch(function (err) { console.error('[coupon-cleaner] falha ao remover cupom:', err); });
    return true;
  }

  function renderBestCouponBadge() {
    // Badge removido — redundante com a linha do cupom no summary
    // ("🎁 CODIGO -R$X") + total riscado+verde. Funcao mantida como
    // no-op pra nao quebrar chamadas existentes.
    var existing = document.querySelector('[data-best-coupon-note]');
    if (existing) existing.remove();
  }

  // =============================================================
  // Brinde automatico: adiciona/remove o produto brinde quando o
  // total do carrinho passa/desce da meta (data-brinde-goal).
  // O item eh marcado com property _brinde: 'true' pra identifica-lo
  // depois (esconder controles de qty/remove na UI).
  // Anti-loop via sessionStorage: nao reprocessa se o estado (in/out)
  // ja foi resolvido pra a mesma configuracao (variant+goal+in?).
  // =============================================================
  // Anti-loop global pra brinde: guarda timestamp da ultima acao.
  // Se tentou add/remove ha menos de 10s, NAO refaz — protege contra
  // loop em cenarios onde variant_id nao bate no find() ou reload
  // dispara reprocessamento antes do cart estabilizar.
  function _brindeThrottled() {
    try {
      var last = parseInt(sessionStorage.getItem('davila_brinde_last_action') || '0', 10);
      var now = Date.now();
      if (now - last < 10000) {
        console.warn('[davila-cart] brinde acao throttled (menos de 10s desde ultima)');
        return true;
      }
      sessionStorage.setItem('davila_brinde_last_action', String(now));
      return false;
    } catch (e) { return false; }
  }

  var _brindeProcessing = false;
  function ensureBrindeInCart(cart) {
    var wrap = document.querySelector('[data-davila-cart]');
    if (!wrap) return;
    if (_brindeProcessing) { console.log('[davila-cart] brinde: ja processando, skip'); return; }
    var variantId = (wrap.dataset.brindeVariantId || '').trim();
    var goalCents = parseInt(wrap.dataset.brindeGoal || '0', 10);
    if (!variantId || !goalCents) return;

    var total = cart.total_price || 0;
    var eligivel = total >= goalCents;

    // Verifica se o brinde ja esta no cart. Compara TAMBEM via propriedade
    // _brinde=true (mais confiavel que variant_id, que pode diferir se o
    // dataset trouxer id de um variant errado).
    var brindeItem = (cart.items || []).find(function (it) {
      return String(it.variant_id) === String(variantId)
          || (it.properties && (it.properties._brinde === 'true' || it.properties._brinde === true));
    });
    var brindeInCart = !!brindeItem;

    console.log('[davila-cart] brinde check', {
      variantId: variantId, goalCents: goalCents, total: total,
      eligivel: eligivel, brindeInCart: brindeInCart,
      brindeKey: brindeItem && brindeItem.key
    });

    if (eligivel && !brindeInCart) {
      _brindeProcessing = true;
      console.log('[davila-cart] adicionando brinde', variantId);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _brinde: 'true' } }],
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return new Promise(function (r) { setTimeout(r, 300); }); })
        .then(function () { return refreshItemsFromCartPage(); })
        .then(function () { return fetchCartAndUpdate(); })
        .catch(function (e) { console.error('[davila-cart] brinde add falhou:', e); window.location.reload(); })
        .finally(function () { _brindeProcessing = false; });
      return;
    }

    if (!eligivel && brindeInCart) {
      _brindeProcessing = true;
      var brindeVarId = brindeItem.variant_id;
      var updates = {}; updates[brindeVarId] = 0;
      console.log('[davila-cart] removendo brinde variant=', brindeVarId);
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return new Promise(function (r) { setTimeout(r, 300); }); })
        .then(function () { return refreshItemsFromCartPage(); })
        .then(function () { return fetchCartAndUpdate(); })
        .catch(function (e) { console.error('[davila-cart] brinde remove falhou:', e); window.location.reload(); })
        .finally(function () { _brindeProcessing = false; });
    }
  }

  // Fetch da PAGINA /cart completa (HTML) — mesmo renderer que da reload.
  // Extrai o <ul> de items e substitui in-place. Sempre consistente pq usa
  // o path oficial de renderizacao do Shopify.
  function refreshItemsFromCartPage() {
    console.log('[davila-cart] refreshItemsFromCartPage INICIO');
    return fetch('/cart?_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'text/html' },
    })
      .then(function (r) {
        console.log('[davila-cart] cart page status:', r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItemsUl = doc.querySelector('[data-davila-cart-items]');
        var currentItemsUl = document.querySelector('[data-davila-cart-items]');
        console.log('[davila-cart] page refresh: newUl=', !!newItemsUl, ' currentUl=', !!currentItemsUl);
        if (!newItemsUl || !currentItemsUl) throw new Error('UL nao encontrado');
        currentItemsUl.style.transition = 'opacity 0.15s';
        currentItemsUl.style.opacity = '0.3';
        return new Promise(function (resolve) {
          setTimeout(function () {
            currentItemsUl.outerHTML = newItemsUl.outerHTML;
            console.log('[davila-cart] items UL substituido');
            resolve();
          }, 150);
        });
      });
  }

  // Refetch /cart.js e aplica no summary
  function fetchCartAndUpdate() {
    return fetch('/cart.js?_=' + Date.now(), {
      credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyCartUpdate(cart, null, null, null); });
  }

  // Re-renderiza APENAS a lista de items sem reload.
  // Formato correto Shopify: /cart.js?sections=SECTION_ID retorna cart JSON
  // com campo extra "sections": { "SECTION_ID": "<html>" }.
  function refreshCartItemsHtml() {
    console.log('[davila-cart] refreshCartItemsHtml INICIO');
    // Cache buster (_=timestamp) evita Cloudflare/CDN servir cart antigo
    return fetch('/cart.js?sections=davila-cart&_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' },
    })
      .then(function (r) {
        console.log('[davila-cart] refresh response status:', r.status);
        return r.json();
      })
      .then(function (cart) {
        var sections = cart && cart.sections;
        var sectionHtml = sections && sections['davila-cart'];
        console.log('[davila-cart] refresh sections keys:', sections ? Object.keys(sections) : 'sem sections');
        if (!sectionHtml) throw new Error('section davila-cart nao retornada');
        var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var newItemsUl = doc.querySelector('[data-davila-cart-items]');
        var currentItemsUl = document.querySelector('[data-davila-cart-items]');
        console.log('[davila-cart] refresh: newUl=', !!newItemsUl, ' currentUl=', !!currentItemsUl);
        if (newItemsUl && currentItemsUl) {
          currentItemsUl.style.transition = 'opacity 0.15s';
          currentItemsUl.style.opacity = '0.3';
          setTimeout(function () {
            currentItemsUl.outerHTML = newItemsUl.outerHTML;
            console.log('[davila-cart] refresh: UL substituido');
          }, 150);
        } else {
          throw new Error('newItemsUl ou currentItemsUl nao encontrado no HTML');
        }
        // Cart JSON ja veio na mesma request — aplica direto no summary
        applyCartUpdate(cart, null, null, null);
      })
      .catch(function (err) {
        console.error('[davila-cart] refreshCartItemsHtml FALHOU, fallback reload:', err);
        window.location.reload();
      });
  }

  // Le codigo do cupom aplicado do cookie discount_code (fallback quando
  // cart.discount_applications vem vazio mas cart.total_discount > 0)
  function readDiscountCodeCookie() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      return m ? decodeURIComponent(m[1]).toUpperCase() : '';
    } catch (e) { return ''; }
  }

  // Sincroniza UI do cupom apos qualquer mudanca de cart:
  // - Renderiza/remove linha "🎁 CODIGO -R$X" logo abaixo do subtotal
  // - Se cupom aplicado: esconde form "Digite seu cupom" + mostra "✓ Aplicado [Remover]"
  // - Se sem cupom: mostra form pra digitar
  function updateCouponUI(cart) {
    var summary = document.querySelector('[data-davila-cart-summary]');
    if (!summary) return;
    var couponBlock = summary.querySelector('.davila-cart__coupon-block');
    if (!couponBlock) return;

    // 1) Primeiro tenta discount_applications (canonico)
    var applied = (cart.discount_applications || [])
      .filter(function (d) { return d.target_type !== 'shipping_line' && d.type !== 'automatic'; })
      .map(function (d) { return { code: (d.title || d.code || '').toUpperCase(), value: d.total_allocated_amount || 0 }; })
      .filter(function (d) { return d.code; });

    // 2) FALLBACK: se discount_applications vazio MAS ha desconto no cart
    // (cart.total_discount > 0 ou original > final), le cupom do cookie.
    // Shopify Ajax API tem bug: cart.total_price ja vem descontado mas
    // discount_applications so' popula apos navegacao. Cookie tem o codigo.
    var totalDiscount = (cart.original_total_price || 0) - (cart.total_price || 0);
    if (applied.length === 0 && totalDiscount > 0) {
      var cookieCode = readDiscountCodeCookie();
      if (cookieCode) {
        applied.push({ code: cookieCode, value: totalDiscount });
      }
    }

    // 1. Linha de desconto no summary (entre subtotal e coupon-block)
    var existingLine = summary.querySelector('.davila-cart__summary-line--discount');
    if (applied.length > 0) {
      var d = applied[0];
      var html = '<div class="davila-cart__summary-line davila-cart__summary-line--discount">' +
        '<span>' + d.code + '</span>' +
        '<span>-' + formatBRL(d.value) + '</span>' +
      '</div>';
      if (existingLine) existingLine.outerHTML = html;
      else couponBlock.insertAdjacentHTML('beforebegin', html);
    } else if (existingLine) {
      existingLine.remove();
    }

    // 2. Estado do coupon-block: form pra digitar OU "aplicado + remover"
    var form = couponBlock.querySelector('[data-cart-coupon-form]');
    var appliedEl = couponBlock.querySelector('[data-davila-coupon-applied]');
    if (applied.length > 0) {
      if (form) form.style.display = 'none';
      var label = couponBlock.querySelector('.davila-cart__coupon-label');
      if (label) label.style.display = 'none';
      if (!appliedEl) {
        var appliedHtml =
          '<div class="davila-cart__coupon-applied" data-davila-coupon-applied>' +
            '<span>✓ Cupom <strong>' + applied[0].code + '</strong> aplicado</span>' +
            '<button type="button" class="davila-cart__coupon-hint-remove" data-davila-remove-coupon>Remover</button>' +
          '</div>';
        couponBlock.insertAdjacentHTML('afterbegin', appliedHtml);
      } else {
        // Atualiza codigo se trocou
        var strongEl = appliedEl.querySelector('strong');
        if (strongEl) strongEl.textContent = applied[0].code;
      }
    } else {
      if (appliedEl) appliedEl.remove();
      if (form) form.style.display = '';
      var label2 = couponBlock.querySelector('.davila-cart__coupon-label');
      if (label2) label2.style.display = '';
    }
  }

  function updateSummary(cart) {
    // Guard: se cart inválido (erro da API), não faz nada — evita NaN no summary
    if (!cart || typeof cart.total_price !== 'number') {
      console.warn('[davila-cart] updateSummary chamado com cart inválido', cart);
      return;
    }
    // Atualiza contador do header "Meu carrinho (N)" com item_count real
    var countEl = document.querySelector('.davila-cart__count');
    if (countEl) countEl.textContent = '(' + (cart.item_count || 0) + ')';
    var subtotalEl = document.querySelector('[data-davila-cart-subtotal]');
    if (subtotalEl) {
      // Subtotal cheio (antes de qualquer cupom) = soma de original_line_price de cada item
      var originalSubtotal = (cart.items || []).reduce(function (acc, it) {
        return acc + (it.original_line_price || it.line_price || 0);
      }, 0);
      subtotalEl.textContent = formatBRL(originalSubtotal || cart.items_subtotal_price || 0);
    }

    // Total: se ha desconto (original > final), mostra riscado + verde
    var totalWrap = document.querySelector('[data-davila-cart-total]');
    var hasDiscount = (cart.original_total_price || 0) > (cart.total_price || 0);
    var savings = hasDiscount ? (cart.original_total_price - cart.total_price) : 0;
    if (totalWrap) {
      var originalHtml = hasDiscount
        ? '<span class="davila-cart__summary-total-original" data-davila-cart-total-original>' + formatBRL(cart.original_total_price) + '</span>'
        : '';
      var finalCls = 'davila-cart__summary-total-final' + (hasDiscount ? ' davila-cart__summary-total-final--discount' : '');
      totalWrap.innerHTML = originalHtml +
        '<span class="' + finalCls + '" data-davila-cart-total-final>' + formatBRL(cart.total_price) + '</span>';
    }

    // Atualiza attributes com cupons aplicados + economia (pra badges lerem).
    // Usa cart.discount_applications (inclui product-level como PREMIUM15,
    // enquanto cart_level_discount_applications so tem order-level).
    var wrap = document.querySelector('[data-davila-cart]');
    if (wrap) {
      if (cart.discount_applications) {
        var codes = cart.discount_applications
          .map(function (d) { return (d.title || '').toUpperCase(); })
          .filter(Boolean).join(',');
        wrap.dataset.appliedCoupons = codes;
      }
      wrap.dataset.cartSavings = savings; // em centavos
    }

    updatePixSummary(cart);
    updateProgressBar(cart);
    updateCouponUI(cart); // sincroniza linha de desconto + form/aplicado in-place

    // Re-avalia melhor cupom (cart mudou) — SO MOSTRA SUGESTAO, nao aplica
    renderCouponSuggestion();
    ensureBrindeInCart(cart);

    // Se cart ficou vazio, recarrega pra mostrar empty state
    if (cart.item_count === 0) {
      setTimeout(function () { window.location.reload(); }, 300);
    }

    // Dispara evento pra outras features
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  // PIX (Luna Checkout): mesma conta do Liquid em davila-cart-page — por unidade:
  // preco com cupom (o aplicado, ou o padrao se nenhum), menos o % do Pix, arredondado
  // PRA CIMA ate o real inteiro. Total = soma. Mantem o numero igual ao da PDP.
  function updatePixSummary(cart) {
    var wrap = document.querySelector('[data-davila-cart]');
    var totalEl = document.querySelector('[data-davila-cart-pix-total]');
    if (!wrap || !totalEl || !cart || !cart.items) return;
    var pixPct = parseInt(wrap.dataset.pixPct, 10) || 0;
    var gPct = parseInt(wrap.dataset.globalPct, 10) || 0;
    var gCode = wrap.dataset.globalCoupon || '';
    var temCupom = (cart.discount_applications || []).length > 0;
    var pix = 0, cupom = 0;
    cart.items.forEach(function (it) {
      var li = document.querySelector('[data-cart-item][data-variant-id="' + it.variant_id + '"]');
      var off = !!(li && li.getAttribute('data-cupom-off') === 'true');
      var unit = it.final_price || 0;
      if (!temCupom && !off && gCode && gPct > 0) unit = Math.floor(unit * (100 - gPct) / 100);
      var pixUnit = Math.ceil(Math.floor(unit * (100 - pixPct) / 100) / 100) * 100;
      pix += pixUnit * it.quantity;
      cupom += unit * it.quantity;
    });
    totalEl.textContent = formatBRL(pix);
    var orig = document.querySelector('[data-davila-cart-pix-original]');
    if (orig) orig.textContent = formatBRL(cart.original_total_price);
    var inst = document.querySelector('[data-davila-cart-pix-install]');
    if (inst) inst.textContent = '10x de ' + formatBRL(Math.floor(cupom / 10));
    // Cupom mostrado/copiado: o aplicado no carrinho > o do influencer (?ref=) > o padrao
    var ref = typeof window.davilaGetRefCoupon === 'function' ? window.davilaGetRefCoupon() : '';
    var code = temCupom ? String(cart.discount_applications[0].title || '').toUpperCase() : (ref || gCode);
    document.querySelectorAll('[data-davila-cart-pix-coupon]').forEach(function (el) { el.textContent = code; });
    var howtoTotal = document.querySelector('[data-davila-cart-pix-total-howto]');
    if (howtoTotal) howtoTotal.textContent = formatBRL(pix);
  }

  // Botao "Copiar cupom" do carrinho
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-davila-cart] [data-davila-copy-coupon]');
    if (!btn) return;
    var el = document.querySelector('[data-davila-cart-pix-coupon]');
    var code = el ? el.textContent.trim() : '';
    if (!code) return;
    var label = btn.textContent;
    var ok = function () { btn.textContent = 'Copiado ✓'; setTimeout(function () { btn.textContent = label; }, 2000); };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(ok, ok); }
    else { var i = document.createElement('input'); i.value = code; document.body.appendChild(i); i.select(); try { document.execCommand('copy'); } catch (x) {} i.remove(); ok(); }
  });

  function updateProgressBar(cart) {
    var wrap = document.querySelector('[data-davila-cart-progress]');
    if (!wrap) return;

    var freeship = parseInt(wrap.dataset.freeshipCents, 10);
    var brinde = parseInt(wrap.dataset.brindeCents, 10);
    var brindeName = wrap.dataset.brindeName || 'brinde';
    var total = cart.total_price || 0;
    var biggest = Math.max(freeship, brinde);
    var pct = Math.min(100, Math.round((total / biggest) * 100));

    // Seta via CSS custom property no wrapper — o fill lê via var(--davila-progress-pct)
    wrap.style.setProperty('--davila-progress-pct', pct + '%');

    var fill = wrap.querySelector('[data-davila-progress-fill]');
    if (fill) {
      // Reforca width via setProperty com important (evita CSS externo anular)
      fill.style.setProperty('width', pct + '%', 'important');
      // Reforça background inline
      fill.style.backgroundColor = '#16a34a';
      fill.style.backgroundImage = 'linear-gradient(90deg, #C9973A 0%, #16a34a 100%)';
      fill.style.borderRadius = '999px';
    }

    var reachedFreeship = total >= freeship;
    var reachedBrinde = total >= brinde;

    var freeshipEl = wrap.querySelector('.davila-cart-progress__milestone--freeship');
    var brindeEl = wrap.querySelector('.davila-cart-progress__milestone--brinde');
    if (freeshipEl) freeshipEl.classList.toggle('is-reached', reachedFreeship);
    if (brindeEl) brindeEl.classList.toggle('is-reached', reachedBrinde);

    var msgEl = wrap.querySelector('[data-davila-progress-message]');
    if (msgEl) {
      if (reachedBrinde) {
        msgEl.innerHTML = '🎉 Você desbloqueou <strong>frete grátis + ' + brindeName + '</strong>!';
      } else if (reachedFreeship) {
        msgEl.innerHTML = '✅ <strong>Frete grátis desbloqueado!</strong> Faltam ' + formatBRL(brinde - total) + ' pra ganhar <strong>' + brindeName + '</strong>';
      } else {
        msgEl.innerHTML = 'Faltam <strong>' + formatBRL(freeship - total) + '</strong> pra <strong>frete grátis</strong>';
      }
    }
  }

  // Aplica update do cart no DOM: line item + summary. Usada tanto no success
  // do /cart/change.js quanto no refetch de /cart.js quando dá erro.
  function applyCartUpdate(cart, key, quantity, itemEl) {
    if (!cart) return;
    if (quantity === 0 && itemEl) {
      itemEl.style.transition = 'opacity 0.25s, max-height 0.25s, margin 0.25s, padding 0.25s';
      itemEl.style.opacity = '0';
      itemEl.style.maxHeight = '0';
      itemEl.style.overflow = 'hidden';
      itemEl.style.padding = '0';
      itemEl.style.margin = '0';
      setTimeout(function () { itemEl.remove(); }, 250);
    } else if (itemEl) {
      // Busca item PRIMEIRO por variant_id (estavel), fallback pra key.
      // key muda quando Shopify reprocessa cart (ex: apos aplicar cupom).
      var variantId = itemEl.dataset.variantId;
      var newItem = (cart.items || []).find(function (i) {
        if (variantId && String(i.variant_id) === String(variantId)) return true;
        return i.key === key;
      });
      if (newItem) {
        // Atualiza data-item-key se mudou (pro proximo change funcionar)
        if (newItem.key && newItem.key !== itemEl.dataset.itemKey) {
          itemEl.dataset.itemKey = newItem.key;
          var qtyInputEl = itemEl.querySelector('[data-davila-qty-input]');
          if (qtyInputEl) qtyInputEl.dataset.itemKey = newItem.key;
          var removeEl = itemEl.querySelector('[data-davila-remove]');
          if (removeEl) removeEl.dataset.itemKey = newItem.key;
        }
        // SINCRONIZA input com quantidade REAL do backend
        var qtyInputSync = itemEl.querySelector('[data-davila-qty-input]');
        if (qtyInputSync && parseInt(qtyInputSync.value, 10) !== newItem.quantity) {
          qtyInputSync.value = newItem.quantity;
        }
        var totalEls = itemEl.querySelectorAll('.davila-cart-item__price-total');
        var installEls = itemEl.querySelectorAll('.davila-cart-item__price-install');
        var unitEl = itemEl.querySelector('.davila-cart-item__unit');
        var installVal = Math.round(newItem.final_line_price / 10);
        totalEls.forEach(function (el) { el.textContent = formatBRL(newItem.final_line_price); });
        installEls.forEach(function (el) { el.textContent = 'ou 10x de ' + formatBRL(installVal) + ' sem juros'; });
        if (unitEl && newItem.quantity > 1) {
          unitEl.textContent = newItem.quantity + ' × ' + formatBRL(newItem.final_price) + ' un';
          unitEl.style.display = '';
        } else if (unitEl) {
          unitEl.style.display = 'none';
        }
      }
    }
    updateSummary(cart);
  }

  function changeCartItem(key, quantity, itemEl) {
    if (itemEl && quantity === 0) itemEl.classList.add('is-removing');

    // Estrategia mais robusta: /cart/update.js com updates:{variantId: qty}
    // NAO depende de item.key (que pode mudar entre operacoes). variant_id
    // esta no data-attribute do <li>, populado pelo Liquid.
    var variantId = itemEl && itemEl.dataset.variantId;
    var payload;
    if (variantId) {
      var updates = {};
      updates[variantId] = quantity;
      payload = { updates: updates };
    } else {
      // Fallback pro metodo antigo com key
      payload = { id: key, quantity: quantity };
    }

    return fetch(variantId ? '/cart/update.js' : '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok || typeof result.data.total_price !== 'number') {
          console.warn('[davila-cart] update retornou erro, re-buscando cart', result.data);
          return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (itemEl) itemEl.classList.remove('is-removing');
              applyCartUpdate(cart, key, quantity, itemEl);
              return cart;
            });
        }
        var cart = result.data;
        applyCartUpdate(cart, key, quantity, itemEl);
        return cart;
      })
      .catch(function (err) {
        console.error('[davila-cart] erro:', err);
        if (itemEl) itemEl.classList.remove('is-removing');
      });
  }

  function lockQty(qtyEl, lock) {
    if (!qtyEl) return;
    if (lock) {
      qtyEl.dataset.pending = '1';
      qtyEl.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    } else {
      qtyEl.dataset.pending = '';
      qtyEl.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
    }
  }

  function setupQtyButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-davila-qty-decrease], [data-davila-qty-increase]');
      if (!btn) return;

      var qtyEl = btn.closest('[data-davila-qty]');
      if (!qtyEl) return;
      // Lock: evita cliques rapidos em paralelo. Espera a request completar
      // pra saber o estado REAL do backend antes de aceitar novo click.
      if (qtyEl.dataset.pending === '1') return;

      var input = qtyEl.querySelector('[data-davila-qty-input]');
      if (!input) return;

      var current = parseInt(input.value, 10) || 0;
      var isIncrease = btn.hasAttribute('data-davila-qty-increase');
      var newQty = isIncrease ? current + 1 : Math.max(0, current - 1);
      if (newQty === current) return;

      // SEM UI otimista: nao muda input antes do backend confirmar.
      // Isso evita "input=1 mas cart=2" quando request trava/falha.
      // Feedback visual: opacity reduzido no wrapper enquanto processa.
      qtyEl.style.opacity = '0.5';
      lockQty(qtyEl, true);

      var itemEl = btn.closest('[data-cart-item]');
      var key = input.dataset.itemKey;
      var done = function () { lockQty(qtyEl, false); qtyEl.style.opacity = ''; };
      var promise = changeCartItem(key, newQty, itemEl);
      if (promise && promise.finally) promise.finally(done);
      else if (promise && promise.then) promise.then(done, done);
      else done();
    });
  }

  function setupQtyInput() {
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-davila-qty-input]');
      if (!input) return;

      var newQty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = newQty;

      var itemEl = input.closest('[data-cart-item]');
      var key = input.dataset.itemKey;
      changeCartItem(key, newQty, itemEl);
    });
  }

  function setupRemoveButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-davila-remove]');
      if (!btn) return;

      var itemEl = btn.closest('[data-cart-item]');
      var key = btn.dataset.itemKey;
      changeCartItem(key, 0, itemEl);
    });
  }

  function syncInitialCart() {
    // Fetch inicial pra garantir que a UI reflete o estado atual do cart.
    if (!document.querySelector('[data-davila-cart-progress]')) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateProgressBar(cart);
        updatePixSummary(cart); // troca pelo cupom do influencer, se houver
        updateCouponUI(cart);
        var wrap = document.querySelector('[data-davila-cart]');
        if (wrap && cart.discount_applications) {
          var codes = cart.discount_applications
            .map(function (d) { return (d.title || '').toUpperCase(); })
            .filter(Boolean).join(',');
          wrap.dataset.appliedCoupons = codes;
        }
        renderCouponSuggestion();
        ensureBrindeInCart(cart);
      })
      .catch(function () { /* silent */ });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Cupom manager (trocar / remover / aplicar)
  // Shopify permite só 1 cupom por carrinho:
  //  - Trocar: /discount/NOVO?redirect=/cart (substitui o atual)
  //  - Remover: /discount/CODE_INEXISTENTE?redirect=/cart (limpa)
  //  - Aplicar: mesmo que trocar
  // ═══════════════════════════════════════════════════════════════════
  function setupCouponManager() {
    // Delegation puro: form + botao "Remover" + botao "Aplicar" da sugestao.
    // Aplica e remove sem reload usando /cart/update.js.

    function findForm() { return document.querySelector('[data-cart-coupon-form]'); }

    document.addEventListener('click', function (e) {
      // Aplicar cupom pelo form (submit)
      var applyBtn = e.target.closest('[data-cart-coupon-form] button[type="submit"]');
      if (applyBtn) {
        e.preventDefault();
        submitCoupon();
        return;
      }
      // Remover cupom aplicado
      var removeBtn = e.target.closest('[data-davila-remove-coupon]');
      if (removeBtn) {
        e.preventDefault();
        removeCoupon(removeBtn);
        return;
      }
    });

    // Enter no input tambem aplica
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest('[data-cart-coupon-form] input[name="code"]');
      if (!input) return;
      e.preventDefault();
      submitCoupon();
    });

    function submitCoupon() {
      var form = findForm();
      if (!form) return;
      var input = form.querySelector('input[name="code"]');
      var raw = (input && input.value ? input.value : '').trim().toUpperCase();
      if (!raw) return;
      if (!/^[A-Z0-9_\-]{2,40}$/.test(raw)) {
        if (input) { input.style.borderColor = '#dc2626'; setTimeout(function () { input.style.borderColor = ''; }, 2000); }
        return;
      }
      var btn = form.querySelector('button[type="submit"]');
      applyCoupon(raw, btn);
    }
  }

  // Detecta tentativa falha de trocar cupom: se URL tem ?tried=X mas cupom
  // atual e diferente, Shopify recusou (geralmente pq o novo e menor que o
  // atual — protecao nativa "manter melhor desconto pro cliente").
  function checkCouponSwapResult() {
    var params = new URLSearchParams(window.location.search);
    var tried = (params.get('tried') || '').toUpperCase();
    if (!tried) return;
    // Le cupons aplicados via attribute que ja e populado por syncCartAttrs
    var wrap = document.querySelector('[data-davila-cart]');
    var appliedRaw = wrap ? (wrap.getAttribute('data-applied-coupons') || '') : '';
    var applied = appliedRaw.split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
    // Se o cupom tentado NAO esta aplicado, foi rejeitado
    if (applied.indexOf(tried) === -1) {
      var current = applied[0] || '';
      showCouponSwapNotice(tried, current);
    }
    // Limpa o param da URL pra nao mostrar aviso em refreshes futuros
    if (window.history && window.history.replaceState) {
      var clean = window.location.pathname;
      window.history.replaceState({}, '', clean);
    }
  }

  function showCouponSwapNotice(tried, current) {
    var actions = document.querySelector('[data-cart-coupon-actions]');
    if (!actions) return;
    // Evita duplicar se ja tem
    if (document.querySelector('[data-cart-coupon-notice]')) return;
    var notice = document.createElement('div');
    notice.setAttribute('data-cart-coupon-notice', '');
    notice.className = 'davila-cart__coupon-notice';
    notice.innerHTML = current
      ? 'Voce ja esta com o melhor cupom aplicado (<strong>' + current + '</strong>). O cupom <strong>' + tried + '</strong> daria menos desconto.'
      : 'Cupom <strong>' + tried + '</strong> nao pode ser aplicado.';
    actions.parentNode.insertBefore(notice, actions.nextSibling);
    // Auto-remove em 8s
    setTimeout(function () {
      if (notice.parentNode) notice.parentNode.removeChild(notice);
    }, 8000);
  }

  // ═══════════════════════════════════════════════════════════════════
  // Frete gratis na calculadora dos Correios
  //
  // O bloco de frete e do app MeuCorreios: ele consulta a transportadora
  // direto e nao enxerga descontos do Shopify. Por isso continua exibindo a
  // tarifa cheia mesmo quando o pedido ja passou da meta, e o cliente le
  // "frete gratis desbloqueado" na barra e ve valores cobrados logo abaixo.
  //
  // Aqui a opcao mais barata recebe um "Gratis" com o valor riscado. E
  // apenas visual: quem zera o frete de fato e o desconto automatico, no
  // checkout.
  //
  // Os precos sao localizados pelo PADRAO DE TEXTO (R$ 00,00) em vez de por
  // classe CSS, porque a marcacao e do app e pode mudar sem aviso.
  // ═══════════════════════════════════════════════════════════════════
  // Guardado aqui fora pra poder pausar enquanto alteramos o DOM nos mesmos.
  // Sem isso, nossa propria alteracao redispara o observador em laco.
  var _obsFrete = null;

  function _pausarObsFrete() {
    if (_obsFrete) _obsFrete.disconnect();
  }

  function _retomarObsFrete(bloco) {
    if (_obsFrete && bloco) _obsFrete.observe(bloco, { childList: true, subtree: true });
  }

  // Tira acento antes de comparar. 'RAPIDO'.indexOf em 'RAPIDO' com A acentuado
  // da -1: o rotulo da modalidade rapida nunca era reconhecido, todos os precos
  // herdavam 'economico' e o desempate caia no preco. Bug real, 28/09/2026.
  function _semAcento(t) {
    return (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function _freteBloco() {
    return document.querySelector('[id*="meucorreios"], [class*="meucorreios"]');
  }

  function _limparMarcacaoFrete(bloco) {
    // Tira os selos que inserimos
    Array.prototype.forEach.call(
      bloco.querySelectorAll('[data-davila-frete-gratis]'),
      function (el) { el.remove(); }
    );
    // Desembrulha o preco: devolve o no de texto pro lugar de origem.
    Array.prototype.forEach.call(
      bloco.querySelectorAll('[data-davila-preco-oculto]'),
      function (el) {
        var pai = el.parentNode;
        if (!pai) return;
        while (el.firstChild) pai.insertBefore(el.firstChild, el);
        pai.removeChild(el);
      }
    );
    // Compatibilidade: a versao anterior trocava o TEXTO do preco por "Gratis".
    // Uma aba aberta antes do deploy ainda pode ter elementos nesse formato.
    Array.prototype.forEach.call(
      bloco.querySelectorAll('[data-davila-riscado]'),
      function (el) {
        if (el.dataset.davilaValorOriginal) {
          el.textContent = el.dataset.davilaValorOriginal;
          delete el.dataset.davilaValorOriginal;
        }
        el.style.textDecoration = '';
        el.style.opacity = '';
        el.style.color = '';
        el.style.fontWeight = '';
        el.removeAttribute('data-davila-riscado');
      }
    );
  }

  function marcarFreteGratis() {
    var wrap = document.querySelector('[data-davila-cart]');
    var bloco = _freteBloco();
    if (!wrap || !bloco) return;

    var meta = parseInt(wrap.dataset.freeshipGoal || '0', 10);
    if (!meta) return;

    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Pausa o observador: o que alteramos abaixo e NOSSO e nao pode
        // disparar outra rodada. Antes isso era evitado por uma trava em
        // data-davila-riscado que saia cedo demais e quase nunca limpava.
        _pausarObsFrete();
        try {

        // Sempre parte do estado natural, com o preco real visivel em TODAS as
        // opcoes. Sem isso a opcao ja marcada sumia da varredura (o texto virava
        // "Gratis" e nao casava mais com R$ 00,00), e a cada recalculo o "Gratis"
        // migrava de linha: a opcao mais lenta aparecia paga e a mais rapida
        // gratis. Bug do CEP, 28/09/2026.
        _limparMarcacaoFrete(bloco);

        if ((cart.total_price || 0) < meta) return;

        // Varre os NOS DE TEXTO do bloco, em ordem de documento.
        //
        // Duas tentativas anteriores falharam por depender da estrutura do app:
        // subir pelo ancestral procurando o nome, e varrer so' elementos-folha.
        // TreeWalker ignora aninhamento: enxerga o texto na ordem em que ele
        // aparece, seja qual for a arvore que o app montar.
        var nos = [];
        var walker = document.createTreeWalker(bloco, NodeFilter.SHOW_TEXT, null, false);
        var no;
        while ((no = walker.nextNode())) {
          var txt = (no.nodeValue || '').trim();
          if (txt) nos.push({ no: no, txt: txt });
        }

        var rotulos = [];
        var precos = [];
        for (var i = 0; i < nos.length; i++) {
          var t = nos[i].txt;
          var T = _semAcento(t).toUpperCase();
          if (T.indexOf('ECON') !== -1 || /\bPAC\b/.test(T)) {
            rotulos.push({ i: i, modo: 'eco' });
          } else if (T.indexOf('RAPID') !== -1 || T.indexOf('SEDEX') !== -1 ||
                     T.indexOf('EXPRESS') !== -1) {
            rotulos.push({ i: i, modo: 'rapido' });
          }
          var m = t.match(/R\$\s*([\d.]+),(\d{2})/);
          if (!m) continue;
          var cents = parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10);
          if (!cents) continue;
          var pai = nos[i].no.parentElement;
          if (!pai || pai.hasAttribute('data-davila-frete-gratis')) continue;
          precos.push({ i: i, no: nos[i].no, cents: cents });
        }

        // Cada preco herda o ULTIMO rotulo que apareceu ANTES dele — que e' a
        // ordem em que a lista e' lida: nome, preco, prazo. Regra sem empate.
        // (Tentei 'o rotulo mais proximo', mas quando o preco fica exatamente
        // entre dois rotulos o desempate vira sorteio.)
        // Se nenhum rotulo vier antes, usa o primeiro da lista.
        var candidatos = precos.map(function (pr) {
          var modo = rotulos.length ? rotulos[0].modo : '';
          for (var k = 0; k < rotulos.length; k++) {
            if (rotulos[k].i <= pr.i) modo = rotulos[k].modo;
            else break;
          }
          return { no: pr.no, cents: pr.cents, isEco: modo === 'eco' };
        });
        if (!candidatos.length) return;

        // Regra do Otavio (28/09/2026): o 'Gratis' vai SEMPRE na modalidade
        // economica, independente do preco. Preco so' decide se nenhuma opcao
        // se identificar como economica — ai marca a mais barata.
        var ecoCandidatos = candidatos.filter(function (c) { return c.isEco; }).sort(function (a, b) { return a.cents - b.cents; });
        var alvo = ecoCandidatos[0]
          || candidatos.sort(function (a, b) { return a.cents - b.cents; })[0];

        // Envolve APENAS o no de texto do preco num span nosso, e esconde esse
        // span. Assim nao arrastamos junto o nome da modalidade, que pode estar
        // no mesmo elemento, e o texto original fica intacto pra proxima leitura.
        var envol = document.createElement('span');
        envol.setAttribute('data-davila-preco-oculto', 'true');
        alvo.no.parentNode.insertBefore(envol, alvo.no);
        envol.appendChild(alvo.no);
        envol.style.display = 'none';

        var selo = document.createElement('span');
        selo.setAttribute('data-davila-frete-gratis', 'true');
        selo.textContent = 'Grátis';
        selo.style.color = '#15823c';
        selo.style.fontWeight = '700';
        envol.parentNode.insertBefore(selo, envol.nextSibling);

        } finally { _retomarObsFrete(bloco); }
      })
      .catch(function () {
        // Melhoria visual nao pode quebrar o carrinho; so garante o observador.
        _retomarObsFrete(bloco);
      });
  }

  function observarCalculadoraFrete() {
    var bloco = _freteBloco();
    if (!bloco) return;

    var agendado = null;
    _obsFrete = new MutationObserver(function () {
      // O app renderiza em etapas; debounce evita trabalho repetido.
      clearTimeout(agendado);
      agendado = setTimeout(marcarFreteGratis, 250);
    });
    _obsFrete.observe(bloco, { childList: true, subtree: true });

    marcarFreteGratis();
  }


  function init() {
    if (!document.querySelector('[data-davila-cart]')) return;
    setupQtyButtons();
    setupQtyInput();
    setupRemoveButtons();
    setupCouponManager();
    syncInitialCart();
    observarCalculadoraFrete();
    renderBestCouponBadge();
    renderCouponSuggestion();
    applyBestCouponIfNeeded();
    checkCouponSwapResult();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
